export default __webpack_public_path__ + "static/media/Book.59671d5b.svg";